import axios, {
    AxiosInstance,
    AxiosError,
    InternalAxiosRequestConfig,
} from "axios";

const API_BASE_URL =
    import.meta.env.VITE_API_BASE_URL || "http://localhost:3000/api";

// Create axios instance
export const apiClient: AxiosInstance = axios.create({
    //This is to stop the API request getting blocked by the browser as a CORS request
    // baseURL: API_BASE_URL,
    withCredentials: true, // Send cookies (e.g. session_id) with every request
    headers: {
        "Content-Type": "application/json",
    },
});

// Token manager functions (imported later to avoid circular dependency)
let getToken: () => string | null;
let clearTokens: () => void;

export const setTokenManager = (
    tokenGetter: () => string | null,
    tokenClearer: () => void
) => {
    getToken = tokenGetter;
    clearTokens = tokenClearer;
};

// Request interceptor - Add JWT token
apiClient.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        if (getToken) {
            const token = getToken();
            if (token && config.headers) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        // Only add x-tenant-id when running locally (dev mode)
        if (import.meta.env.DEV && config.method?.toLowerCase() !== "options") {
            config.headers["x-tenant-id"] = "mpt";
        }

        return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    }
);

// Response interceptor - Handle errors and 401 unauthorized
apiClient.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
        // Handle 401 Unauthorized - clear tokens and potentially redirect
        if (error.response?.status === 401) {
            if (clearTokens) {
                clearTokens();
            }
            // Redirect to login could be handled here or in the component
            if (
                typeof window !== "undefined" &&
                !window.location.pathname.includes("/login")
            ) {
                window.location.href = "/login";
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;
